import Lottie from 'react-lottie-player';
import loadingWhite from 'torque-ui/assets/animations/loading-white.json';
import loadingBlack from 'torque-ui/assets/animations/loading-black.json';

import { ILoader } from './types';
import { cn } from 'torque-ui/lib/utils';

const Loader = ({ color = 'white', className, text, bold, file }: ILoader) => {
  return (
    <div className="flex flex-col justify-center items-center h-full">
      <Lottie
        className={className}
        animationData={
          !!file ? file : color === 'black' ? loadingBlack : loadingWhite
        }
        play
      />
      {text && (
        <span className={cn(
          bold ? 'font-medium text-sm' : '',
          color === 'black' ? 'text-black' : 'text-white'
        )}>{text}</span>
      )}
    </div>
  );
};

export default Loader;
